import UturnArrow from './uturn-arrow.js'
import uturn from './helpers/right-uturn-arrow.js'

export default class RightInwardUturnArrow extends UturnArrow {

  constructor (id, data) {
    super(id, data)
    this.isLeft = false
    this.lockedBase = false
  }

  handles = [{
    // Arrow head height/width
    defaults: [.87, .7],
    constraints: (dimensions, handles) => {
      const minY = this.calculateMinY(dimensions, handles, this.isLeft)
      const minX = 1 - (1 / 6) // This prevents the left side of the arrow from leaking into the left side of the arrow base

      return [
        [minX, .99], [minY, 1]
      ]
    },
    cursor: 'all-scroll'
  }, {
    // Outer radius at the top of the symbol
    defaults: [.34, 0],
    constraints: (dimensions, handles) => {
      return [
        [0, .5 - (1 - handles[0].coords[0])], null
      ]
    },
    cursor: 'ew-resize'
  }, {
    // Base length of the arrow
    defaults: [13, .53],
    constraints: (dimensions, handles) => {
      const minY = this.calculateMinY(dimensions, handles, this.isLeft)

      return [
        null, [minY, 1]
      ]
    },
    cursor: 'ns-resize'
  }]

  path (dimensions, handles) {
    return uturn(dimensions, handles, dimensions.height * handles[2][1], this.properties.tipHeight)
  }

}
